import {
	MOTOKO_DOLLAR_LOGO,
	PLATFORM_NAME,
	PLATFORM_TAGLINE,
	ROUTES,
} from "@/lib/routes";
import { cn } from "@/lib/utils";
import { Link } from "react-router-dom";

/** MotokoDollar-only brand — no MotokoMaker dual logo. */
export function BrandLockup({ compact }: { compact?: boolean }) {
	return (
		<Link
			to={ROUTES.home}
			className={cn("flex min-w-0 items-center", compact ? "gap-1.5" : "gap-2.5")}
		>
			<img
				src={MOTOKO_DOLLAR_LOGO}
				alt={PLATFORM_NAME}
				className={cn("shrink-0 object-contain", compact ? "h-8 w-8" : "h-9 w-9")}
			/>
			<div className="min-w-0 leading-tight">
				<p
					className={cn(
						"truncate font-bold tracking-tight text-foreground",
						compact ? "text-sm" : "text-base",
					)}
				>
					{PLATFORM_NAME}
				</p>
				<p className="hidden truncate text-[10px] text-muted-foreground sm:block">
					{PLATFORM_TAGLINE}
				</p>
			</div>
		</Link>
	);
}

/** @deprecated */
export function DualBrandLockup(props: { compact?: boolean }) {
	return <BrandLockup {...props} />;
}
